"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageButton = void 0;
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const ImageButton = ({ src, imageName, onInteract, gameplayStyle: componentStyle, className, highlighted, width, height, disabled, maxHeight, maxWidth, blurred, }) => {
    const [loading, setLoading] = (0, react_1.useState)(true);
    return loading ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("img", { src: src, style: { display: 'none' }, onLoad: () => setLoading(false), onError: () => setLoading(false) }),
        react_1.default.createElement(material_1.CircularProgress, { variant: "indeterminate", value: 30 }))) : (react_1.default.createElement("img", { onClick: () => {
            if (onInteract && !disabled) {
                onInteract(imageName);
            }
        }, src: src, alt: src, height: height ? height : 'auto', width: width ? width : '100%', className: `${className}-${componentStyle} ${highlighted ? 'highlighted' : ''} ${blurred ? 'blurred' : ''} ${disabled ? 'disabled' : ''}`, "aria-disabled": true, style: {
            maxHeight: maxHeight ? maxHeight : '',
            maxWidth: maxWidth ? maxWidth : '',
        } }));
};
exports.ImageButton = ImageButton;
